import axios from 'axios';

const api = axios.create({
  baseURL: 'https://consultaveiculos.com.br/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

export const getVehiclePreview = async (placa) => {
  const payload = { placa };
  const response = await api.post('/resultado', payload);
  return response.data;
};

export const processPayment = async (paymentDetails) => {
  try {
    const response = await api.post('/pagamento/gerar', paymentDetails);
    return response.data; 
  } catch (error) {
    console.error("Erro ao gerar pagamento:", error);
    throw error;
  }
};

export const getFullVehicleReport = async (payload) => {
  try {
    const response = await api.post('/resultado-completo/', payload );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar relatório completo agregado:", error);
    throw error;
  }
};

export const getUpsellOptions = async () => {
  try {
    const response = await api.get('/itens');
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar opções de upsell:", error);
    throw error;
  }
};


export const getBoughtItems = async (orderId) => {
  try {
    const response = await api.get('/itens-comprados', {
      params: { order_id: orderId }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar itens comprados:", error);
    throw error;
  }
};

export const getOrderDetails = async (orderId) => {
  // Adicionado um log para sabermos qual ID está sendo usado na chamada.
  console.log(`[getOrderDetails] Passo 1: Iniciando busca para orderId: "${orderId}"`);

  // Adicionada uma verificação para garantir que o orderId não é nulo ou vazio.
  if (!orderId) {
    console.error("[getOrderDetails] ERRO: O orderId fornecido é inválido. A chamada foi cancelada.");
    return { success: false, message: "ID do pedido inválido." };
  }

  try {
    const params = { order_id: orderId };
    console.log("[getOrderDetails] Passo 2: Fazendo chamada GET para '/api/order-details' com os parâmetros:", params);

    const response = await api.get('order-details', { params });

    // Adicionada uma verificação para garantir que a resposta tem o formato esperado.
    if (response && response.data && response.data.success) {
      console.log("[getOrderDetails] Passo 3: Sucesso! Dados recebidos da API:", response.data);
      return response.data;
    } else {
      // Caso a API responda 200 OK, mas com 'success: false' ou formato incorreto.
      console.error("[getOrderDetails] ERRO: A API respondeu com sucesso, mas os dados estão em um formato inesperado.", response.data);
      throw new Error("Resposta inválida do servidor.");
    }

  } catch (error) {
    // Bloco CATCH aprimorado para dar o máximo de detalhes sobre o erro.
    console.error("[getOrderDetails] CRÍTICO: A chamada à API falhou e caiu no bloco catch.");

    if (error.response) {
      // Erro vindo da resposta do servidor (ex: 404, 500).
      console.error("[getOrderDetails] Detalhes do erro da API:", {
        status: error.response.status,
        data: error.response.data,
      });
      // Extrai a mensagem de detalhe enviada pelo FastAPI.
      const errorMessage = error.response.data?.detail || `Erro ${error.response.status} no servidor.`;
      return { success: false, message: errorMessage };

    } else if (error.request) {
      // Erro de rede (servidor offline, CORS, etc.).
      console.error("[getOrderDetails] Erro de Rede: Nenhuma resposta recebida.", error.request);
      return { success: false, message: "Não foi possível conectar ao servidor. Verifique sua rede." };

    } else {
      // Outro tipo de erro (ex: erro no código antes de fazer a chamada).
      console.error("[getOrderDetails] Erro inesperado:", error.message);
      return { success: false, message: `Erro inesperado: ${error.message}` };
    }
  }
};


export const verificarStatusPagamento = async (paymentId, tipoPedido) => {
  try {
    const response = await api.get('/pagamento/status', { 
      params: {
        pedido: paymentId,
        tipo_pedido: tipoPedido
      }
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao verificar status do pagamento:", error);
    throw error;
  }
};

export const getPaidProducts = async (orderId) => {
  try {
    const response = await api.get(`/pedidos/${orderId}/produtos`);
    return response.data.produtos;
  } catch (error) {
    console.error("Erro ao buscar produtos já comprados:", error);
    throw error;
  }
};

